import Model from "../Model.js";

export const manualImportModeId = "Manual";

export const autoImportModeId = "Auto";

/**
 * CompanyCapegoIntegrationSettings configures how a company is
 * integrated with Capego.
 *
 * @param {string} importMode - Possible values are defined
 *   by the variables `manualModeId` and `autoModeId`.
 */
export default class CompanyCapegoIntegrationSettings extends Model {
	constructor({ importMode = manualImportModeId } = {}) {
		super(...arguments);

		this._importMode = importMode;
	}

	getImportMode() {
		return this._importMode;
	}

	isManualImportMode() {
		return this._importMode === manualImportModeId;
	}

	changeToManualImportMode() {
		this._importMode = manualImportModeId;
	}

	changeToAutoImportMode() {
		this._importMode = autoImportModeId;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.mode = this._importMode;

		return properties;
	}

	static transformMaterializationData(data, _context) {
		super.transformMaterializationData(...arguments);

		data.importMode = data.mode;
	}
}
